var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabbarCheckedSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6414_3016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.06641 17.998H14.9121C16.9629 17.998 17.9785 16.9824 17.9785 14.9707V3.04688C17.9785 1.03516 16.9629 0.0195312 14.9121 0.0195312H3.06641C1.02539 0.0195312 0 1.02539 0 3.04688V14.9707C0 16.9922 1.02539 17.998 3.06641 17.998ZM7.90039 13.7695C7.56836 13.7695 7.29492 13.6328 7.04102 13.291L4.58984 10.2832C4.44336 10.0879 4.35547 9.87305 4.35547 9.64844C4.35547 9.20898 4.69727 8.84766 5.14648 8.84766C5.41992 8.84766 5.63477 8.93555 5.87891 9.25781L7.86133 11.8164L12.0312 5.11719C12.2168 4.82422 12.4707 4.66797 12.7344 4.66797C13.1543 4.66797 13.5547 4.96094 13.5547 5.41992C13.5547 5.63477 13.4375 5.85938 13.3105 6.06445L8.7207 13.291C8.51562 13.6133 8.23242 13.7695 7.90039 13.7695Z",
    fill: "#1D1E2C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6414_3016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9785,
    height: 17.998,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabbarCheckedSelected);
export default __webpack_public_path__ + "static/media/tabbar-checked-selected.79d7214830e75c924359807c581efaff.svg";
export { ForwardRef as ReactComponent };